import { render, staticRenderFns } from "./Whitelabel.vue?vue&type=template&id=2832957b&scoped=true"
import script from "./Whitelabel.vue?vue&type=script&lang=js"
export * from "./Whitelabel.vue?vue&type=script&lang=js"
import style0 from "./Whitelabel.vue?vue&type=style&index=0&id=2832957b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2832957b",
  null
  
)

export default component.exports